<!-- <div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div> -->
<div  *ngIf="!showStatus" class="outside-container mt-3">
  <div class="box-container">
   <div class="container">
       <div class="title">
         <div class="row">
          <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
         <div class="col-md-7 d-flex justify-content-center">CART DASHBOARD</div>
         <div class=" col-md-3 row ">
           <div class="d-flex justify-content-end">
                <button *ngIf="!moreFilters" mat-flat-button class="btn  btn-sm " (click)="onClickFilters()">More Filters <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <button *ngIf="moreFilters" mat-flat-button class="btn  btn-sm " (click)="onClickFilters()">More Filters <mat-icon>keyboard_arrow_up</mat-icon>
                </button>

           <!-- <button class="btn btn-outline-primary btn-sm " (click)="onAddNew()"><img src="assets/images/Add_24.png"></button> -->
         </div>
          </div>
        </div>
       </div>
<div class="col-md-12 mt-2 col-md-2">
       <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2" style="text-align: left;" (selectedTabChange)="onTabChange($event)">
          <mat-tab  label="Air"> 
            <!-- <div class="col-md-12 d-flex justify-content-start mt-3 mb-3">
     <button (click)="bookingStatus('NEW')"  style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 140px;" mat-flat-button>NEW</button>
     <button (click)="bookingStatus('BOOKED')" style="background-color:#44D43B;color:white;margin-right: 8px;;min-width: 140px;" mat-flat-button>BOOKED</button>
     <button (click)="bookingStatus('PARTIALLYBOOKED')" style="background-color:#FEC000;color:white;margin-right: 8px;;min-width: 140px;" mat-flat-button>PARTIALLY BOOKED</button>

     <button (click)="bookingStatus('ABORTED')" style="background-color:#FF0000;color:white;margin-right: 8px;;min-width: 140px;" mat-flat-button>ABORTED</button>
     <button (click)="bookingStatus('TO CANCEL')" style="background-color:#FF0000;color:white;margin-right: 8px;;min-width: 140px;" mat-flat-button >TO CANCEL</button>
     <button (click)="bookingStatus('CANCELLED')" style="background-color:#FFA500;color:white;margin-right: 8px;;min-width: 140px;" mat-flat-button>CANCELLED</button>

    </div> -->
    <div *ngIf="moreFilters" class="col-md-12 mt-2 mb-2 shadow">
    <div  class="col-md-12 row">
      
      <div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
        <mat-label >Ticket Number</mat-label>
        <input  matInput type="text"    name="ticketNumber"  autocomplete="off" [(ngModel)]="pera.ticketNumber"  (input)="searchByOrderId()">
        </mat-form-field>
      </div>
<div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
          <mat-label >Corporate/Agent</mat-label>
          <!-- <input  matInput type="text"     name="corporatea&agent"  autocomplete="off" [(ngModel)]="pera.corporate"  (input)="searchByOrderId()"> -->
       
            
         
            <input matInput
            [matAutocomplete]="autoTo"
            [formControl]="ToCtrl" >
          <mat-autocomplete #autoTo="matAutocomplete">
            <mat-option   value="ALL"  (click)="selectedTo('')" class="mat-primary" >
              <small>{{'ALL'}}</small>
            </mat-option>
            <mat-option  *ngFor="let user of filteredTo | async" [value]="user.name"  (click)="selectedTo(user)" class="mat-primary" >
              <small>{{user?.name}}, {{user?.userType}}</small>
            </mat-option>
            
          </mat-autocomplete>
    
          
        </mat-form-field>
</div>
<div class="col-md-3">
  <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
    <mat-label >Passenger <small>(FirstName<mat-icon class="pt-1"> space_bar</mat-icon>LastName)</small></mat-label>
  <input  matInput type="text"     name="passenger"  autocomplete="off" [(ngModel)]="pera.passenger"  (input)="searchByOrderId()">
 

    
  </mat-form-field>
</div>
<div class="col-md-3">
<mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
  <mat-label >Booking Status</mat-label>
  <mat-select matNativeControl multiple [(ngModel)]="pera.status" (selectionChange)="searchByOrderId()">
    <mat-option class="mat-primary" value="B">BOOKED</mat-option>
    <mat-option class="mat-primary" value="Z">PARTIALLY BOOKED</mat-option>
    <mat-option class="mat-primary" value="R">PAYMENT FAILED</mat-option>
    <mat-option class="mat-primary" value="T">PENDING TICKET</mat-option>

    <mat-option class="mat-primary" value="F">FAILED</mat-option>
    <mat-option class="mat-primary" value="A">ABORTED</mat-option>
    <mat-option class="mat-primary" value="TC">TO CANCEL</mat-option>
    <mat-option class="mat-primary" value="C">CANCELLED</mat-option>
    <mat-option class="mat-primary" value="N">New</mat-option>
    
  </mat-select>
 
  <!-- <input  matInput type="text"     name="bookedBy" placeholder="Search By PNR" autocomplete="off"   (input)="searchByOrderId()"> -->
</mat-form-field>
</div>

<div class="col-md-3">
  <!-- <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
    <input matInput    [matDatepicker]="picker" [max]="maxDate" [(ngModel)]="pera.fromDate" (dateChange)="searchByOrderId()" >
    <mat-label>From</mat-label>
    <mat-hint>MM/DD/YYYY</mat-hint>

    <mat-datepicker-toggle matIconSuffix [for]="picker" ></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field> -->
<mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
  <mat-label>From</mat-label>
  <mat-hint>MM/DD/YYYY</mat-hint>
  <input matInput [ngxMatDatetimePicker]="picke" readonly [max]="maxDate" placeholder="Choose a date" [(ngModel)]="pera.fromDate" (dateChange)="searchByOrderId()"
     [disabled]="disabled">
  <button mat-icon-button matSuffix (click)="picke.open()">
    <mat-icon>calendar_today</mat-icon>
  </button> 
  <ngx-mat-datetime-picker #picke [showSpinners]="showSpinners" [showSeconds]="showSeconds"
    [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
    [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
    [disableMinute]="disableMinute" [hideTime]="hideTime">
  </ngx-mat-datetime-picker> 
</mat-form-field>
</div>
<div class="col-md-3">
  <!-- <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
    <input matInput    [matDatepicker]="pickers" [max]="maxDate"  [(ngModel)]="pera.toDate"  (dateChange)="searchByOrderId()" >
    <mat-label>To</mat-label>
    <mat-hint>MM/DD/YYYY</mat-hint>

    <mat-datepicker-toggle matIconSuffix [for]="pickers" ></mat-datepicker-toggle>
    <mat-datepicker #pickers></mat-datepicker>
</mat-form-field> -->
<!-- [min]="minDate" [max]="maxDate" -->
<mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
  <mat-label>To</mat-label>
    <mat-hint>MM/DD/YYYY</mat-hint>
  <input matInput [ngxMatDatetimePicker]="picker" readonly [max]="maxDate" placeholder="Choose a date" [(ngModel)]="pera.toDate"  (dateChange)="searchByOrderId()"
     [disabled]="disabled">
  <button mat-icon-button matSuffix (click)="picker.open()">
    <mat-icon>calendar_today</mat-icon>
  </button> 
  <ngx-mat-datetime-picker #picker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
    [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
    [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
    [disableMinute]="disableMinute" [hideTime]="hideTime">
  </ngx-mat-datetime-picker> 
</mat-form-field>
</div>

<div class="col-md-3">
  <mat-form-field class="col-md-12 mt-1  " appearance="outline">
    <mat-label>Branch Id</mat-label>
    <!-- <input matInput type="text" name="name" autocomplete="off"> -->
    <mat-select matNativeControl   name="branchid" [(ngModel)]="pera.branchId" (selectionChange)="searchByOrderId()">
      <mat-option  value="">-</mat-option>

      <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
  </mat-select>
  </mat-form-field>
  <!-- <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
    <mat-label >Booked By</mat-label>
    <input matInput
    [matAutocomplete]="autoBookedBy"
    [formControl]="bookedBYCtrl" >
  <mat-autocomplete #autoBookedBy="matAutocomplete">
    <mat-option   value="ALL"  (click)="selectedBookedBY('')" class="mat-primary" >
      <small>{{'ALL'}}</small>
    </mat-option>
    <mat-option  *ngFor="let user of filteredBookedBY | async" [value]="user.name"  (click)="selectedBookedBY(user)" class="mat-primary" >
      <small>{{user?.name}}</small>
    </mat-option>
    
  </mat-autocomplete>
  </mat-form-field> -->
</div>
<div class="col-md-3">
  <mat-form-field  class="col-md-12 mt-1" appearance="outline">
    <mat-label>Carrier</mat-label>
    <input type="text"
           placeholder="Search..."
           matInput
           [formControl]="myControl"

           [matAutocomplete]="auto">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="changeCarrier()">
   <mat-option value="">All</mat-option>
      <mat-option *ngFor="let option of filteredOptions | async;" [value]="option.carrierName+','+option.airlineDesignatorCode">{{option?.carrierName+','+option?.airlineDesignatorCode}}</mat-option>
      
    </mat-autocomplete>
  </mat-form-field>
</div>
<div class="col-md-3">
  <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
    <mat-label >Type</mat-label>
    <mat-select matNativeControl  [(ngModel)]="pera.segmentType" (selectionChange)="searchByOrderId()">
      <mat-option class="mat-primary" value="">Any</mat-option>
      <mat-option class="mat-primary" value="D">Domestic</mat-option>
      <mat-option class="mat-primary" value="I">International</mat-option>
     
    </mat-select>
   
    <!-- <input  matInput type="text"     name="bookedBy" placeholder="Search By PNR" autocomplete="off"   (input)="searchByOrderId()"> -->
  </mat-form-field>
</div>

    </div>
  </div>
    
    <div class="row col-md-12">
      <div class="col-md-4 row" >
<div class="col-md-6">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
      
      <input  matInput type="text"    name="cartId" placeholder="Search By CartId" autocomplete="off" [(ngModel)]="pera.orderId"  (input)="searchByOrderId()">
      </mat-form-field>
    </div>
<div class="col-md-6">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
      
        <input  matInput type="text"     name="pnr" placeholder="Search By PNR" autocomplete="off" [(ngModel)]="pera.pnr"  (input)="searchByOrderId()">
      </mat-form-field>
</div>

      
      <!-- <mat-menu #OpenDialog="matMenu" >
        <button mat-menu-item (click)="searchBy('CARTID')">Search by CartId</button>
        <button mat-menu-item (click)="searchBy('PNR')">Search by PNR</button>
      
      </mat-menu> -->
    </div>
     
      <!-- <div class="col-md-1 "><button mat-icon-button  style="margin-top: 8px;" (click)="refresh()"><mat-icon  style="color: #4986E8; cursor: pointer;font-weight: 700;" >refresh</mat-icon><small style="white-space: nowrap;"><strong>Last Updated :</strong>{{formatDate(airRefDate)}}</small></button>
      </div> -->
      <div class="col-md-1 "><button mat-flat-button   style="color: #4986E8; cursor: pointer;font-weight: 700;margin-top: 8px;height: 50px;" (click)="refresh()"><mat-icon   >refresh</mat-icon><small style="white-space: nowrap;"><strong>Last Updated :</strong><br>{{formatDate(airRefDate)}}</small></button>
      </div>
      <mat-paginator  class="col-md-7 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100,200,300,400]"
      [length]="totalElements"
      (page)="nextPage($event)"
      aria-label="Select page">
      </mat-paginator>

      </div>
      <div class="d-flex justify-content-start" style="font-size: 12px;">
        <strong class="pt-2">Invoice Status :</strong>
       <button mat-flat-button style="background-color:orange ;color: white;margin-left: 8px;" (click)="onClick('N')">NEW</button>  
       <button mat-flat-button style="background-color:rgb(231, 75, 75) ;color: white;margin-left: 8px;" (click)="onClick('P')">PENDING</button>  
       <button mat-flat-button style="background-color:rgb(25, 143, 25) ;color: white;margin-left: 8px;" (click)="onClick('S')">SUCCESS</button>  
       <button mat-flat-button style="background-color:rgba(6, 204, 243, 0.941) ;color: white;margin-left: 8px;" (click)="onClick('')">ALL</button>  
      <mat-form-field style="margin-left: 8px;" appearance="outline">
        <mat-label>Ticket Issuance Status</mat-label>
       <mat-select matNativeControl  [(ngModel)]="pera.ticketIssuance" (selectionChange)="searchByOrderId()">
        <mat-option class="mat-primary" value="">All</mat-option>
        <mat-option class="mat-primary" value="C">Complete</mat-option>
        <mat-option class="mat-primary" value="F">Failed</mat-option>

      </mat-select>
    </mat-form-field>
    <div style="margin-left: 8px;">

      <button  mat-raised-button color="primary" (click)="exportData()">Export Data</button>

    </div>

      </div>
      <mat-progress-bar *ngIf="showAirTableData" mode="indeterminate"></mat-progress-bar>

            <table *ngIf="!showAirTableData" mat-table style="font-size: 18px; "
            [dataSource]="airList" multiTemplateDataRows style="background-color: transparent;">
            <ng-container matColumnDef="expand">
            <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element" [style]="element.cartType==='M'?('background-color:#4986E8;'):''">
            <button mat-icon-button aria-label="expand row"  (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
              <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
              <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
            </button>
            </td>
            </ng-container>
            <ng-container matColumnDef="generationTime">
             <th mat-header-cell *matHeaderCellDef> Generation Time </th>
             <td mat-cell *matCellDef="let element;"> {{formatDate(element?.creationTs)}} </td>
            </ng-container>
            <!-- Emp Id -->
             <ng-container matColumnDef="firstDeparture">
               <th mat-header-cell *matHeaderCellDef>First Departure</th>
               
               <td mat-cell *matCellDef="let element"> {{formatDate(element?.airItineraries[0]?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}} </td>
             </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="cartId">
              <th mat-header-cell *matHeaderCellDef> CartId </th>
              <td mat-cell *matCellDef="let element"> {{element?.uuid}} </td>
             </ng-container>
            <ng-container matColumnDef="bookedBy">
             <th mat-header-cell *matHeaderCellDef> Booked By </th>
             <td mat-cell *matCellDef="let element"> {{element?.createdBy?.split('-')[1]}} </td>
            </ng-container>
            
            <!-- email Column -->
            <ng-container matColumnDef="corporate_Agent">
             <th mat-header-cell *matHeaderCellDef>Corporate/Agent  </th>
             <td mat-cell *matCellDef="let element"> {{element?.corporate?.split('-')[1]||'-'}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Invoice Status </th>
              <td mat-cell *matCellDef="let element" [style]="element?.invoiceStatus==='S'?('background-color:rgb(25, 143, 25);color:white'):element?.invoiceStatus==='P'?('background-color:rgb(231, 75, 75);color:white'):element?.invoiceStatus==='N'?('background-color:orange;color:white'):''">
                 <!-- {{element?.invoiceStatus}}  -->
                 {{element?.invoiceStatus==='N'?('NEW'):''}}
                  {{element?.invoiceStatus==='P'?('PENDING'):''}}
                  {{element?.invoiceStatus==='S'?('SUCCESS'):''}}
                
                </td>
             </ng-container>
             <ng-container matColumnDef="summary">
              <th mat-header-cell *matHeaderCellDef>Summary </th>
              <td mat-cell *matCellDef="let element" style="padding: 4px;"> <span *ngFor="let Itineraries of element.airItineraries" ><pre>{{Itineraries?.airline}}-{{Itineraries?.flightNumber}}|{{Itineraries?.sector}}|{{formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}{{Itineraries?.orderPassengerDetails?.length?('_X_'+Itineraries?.orderPassengerDetails?.length):''}}</pre></span> </td>
             </ng-container>
             
             <ng-container matColumnDef="approvalStatus">
              <th mat-header-cell *matHeaderCellDef>Service Time </th>
              <td mat-cell *matCellDef="let element"> 
                {{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}
                </td>
             </ng-container>
              
             <ng-container matColumnDef="bookingStatus">
              <th mat-header-cell *matHeaderCellDef>Booking Status</th>
              <td mat-cell *matCellDef="let element" class="d-flex justify-content-center pt-1">
             <button *ngIf="element.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
             <button *ngIf="element.status==='B'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>BOOKED</button>
             <button *ngIf="element.status==='Z'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
             <button  *ngIf="element.status==='F'||element.status==='P'||element.status==='S'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
             <!-- <button  *ngIf="element.status==='S'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button> -->
             <button  *ngIf="element.status==='R'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PAYMENT FAILED</button>
             <button  *ngIf="element.status==='T'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PENDING TICKET</button>

             <button  *ngIf="element.status==='A'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>ABORTED</button>
             <button  *ngIf="element.status==='TC'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button >TO CANCEL</button>
             <button  *ngIf="element.status==='C'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
             <button  *ngIf="element.status==='X'" style="background-color:#ff5e00;color:white;min-width: 140px;" mat-flat-button>Partially Cancelled</button>
             <button  *ngIf="element.status==='CR'" style="background-color:#c70d0d;color:white;min-width: 140px;" mat-flat-button>Cancellation Requested</button>
             <button  *ngIf="element.status==='PS'" style="background-color:#FEC000;;color:white;min-width: 140px;" mat-flat-button>Partially Reschedule</button>
             <button  *ngIf="element.status==='RS'" style="background-color:#FEC000;;color:white;min-width: 140px;" mat-flat-button> Rescheduled</button>


              </td>
             </ng-container>
             <ng-container matColumnDef="paymentStatus">
              <th mat-header-cell *matHeaderCellDef>Payment Status</th>
              <td mat-cell *matCellDef="let element">
                {{element?.paymentStatus==='P'?('PAID'):''}}
                {{element?.paymentStatus==='F'?('FAILED'):''}}
                {{element?.paymentStatus==='I'?('INITIATED'):''}}
                {{element?.paymentStatus==='A'?('ABORTED'):''}}
                {{element?.paymentStatus==='U'?('UNPAID'):''}}

              </td>
             </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
            <div class="example-element-detail row"
             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
             <div class=" col-md-12  mt-2 mb-2 card shadow pb-3">
             <div class="col-md-12 d-flex justify-content-start mt-2">
            <div class="col-md-6 row">
            <span class="col-md-5 bold">Payment Status</span>
            <span class="col-md-7"> 
              {{element?.paymentStatus==='P'?('PAID'):''}}
              {{element?.paymentStatus==='F'?('FAILED'):''}}
              {{element?.paymentStatus==='I'?('INITIATED'):''}}
              {{element?.paymentStatus==='A'?('ABORTED'):''}}
            </span>
            </div>
            <div class="col-md-6 row">
              <span class="col-md-5 bold">Supplier Service Time</span>
              <span class="col-md-7"> {{element?.bookingTs?(element?.bookingRequestTs?(supplierService(element?.bookingTs,element?.bookingRequestTs)):'-'):'-'}}</span>
              </div>

            </div>
            <div class="col-md-12 d-flex justify-content-start mt-2">
              <div class="col-md-6 row">
              <span class="col-md-5 bold">Locked By/ Assigned To</span>
              <span class="col-md-7">{{"-"}}</span>
              </div>
              <div class="col-md-6 row">
                <span class="col-md-5 bold">User/Agent Service Time</span>
                <span class="col-md-7"> {{element?.bookingRequestTs?(ServiceUser(element?.bookingRequestTs,element?.creationTs)):'-'}}</span>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-start mt-2">
                <div class="col-md-6 row">
                <span class="col-md-5 bold">Request Id</span>
                <span class="col-md-7">{{element?.requestUuid||'-'}}</span>
                </div>
                <div class="col-md-6 row">
                  <span class="col-md-5 bold">Total Service Time</span>
                  <span class="col-md-7">{{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}</span>
                  </div>
                </div>
                <div class="col-md-12 d-flex justify-content-start mt-2">
                  <div class="col-md-6 row">
                  <span class="col-md-5 bold">Booking Platform</span>
                  <span class="col-md-7">{{element?.channel||'-'}}</span>
                  </div>
                  <div class="col-md-6 row">
                    <span class="col-md-5 bold">Ticket Issuance Status</span>
                    <span class="col-md-7" [style]="element?.airItineraries[0]?.docIssuanceStatus==='F'?('color:red'):element?.airItineraries[0]?.docIssuanceStatus==='C'?('color:green'):''">{{element?.airItineraries[0]?.docIssuanceStatus==='F'?('Not Issued'):element?.airItineraries[0]?.docIssuanceStatus==='C'?('Issued'):'N/A'}}</span>
                    </div>
                  </div>
                  
                  <div class="col-md-12 d-flex justify-content-start mt-2">
                    <div class="col-md-6 row">
                    <span class="col-md-5 bold">Approval Status</span>
                    <span class="col-md-7"> {{element?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                      {{element?.approvalStatus==='P'?('PENDING'):''}}
                      {{element?.approvalStatus==='D'?('DECLINED'):''}}
                      {{element?.approvalStatus==='A'?('APPROVED'):''}}
      
                      {{element?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                      {{element?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}</span>
                    </div>
                    <div class="col-md-6 row">
                      <span class="col-md-5 bold">Cart Type</span>
                      <span class="col-md-7" >{{element.cartType==='A'?('Auto'):element.cartType==='M'?('Manual'):''}}</span>
                      </div>
                    
                    </div>
                   

                     
              <div class="col-md-12 d-flex justify-content-start mt-2">
                <div class="col-md-6  row">
                <span class="col-md-12 "> 
                  <button (click)="onCartStatusClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>CART STATUS</button>
                  <button (click)="onModifyClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>MODIFY</button>
                  <button *ngIf="element.status==='Z'||element.status==='B'||element.status===''" mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" [matMenuTriggerFor]="showDialog"  ><mat-icon>keyboard_arrow_down</mat-icon>Download as PDF</button>
                  <mat-menu #showDialog="matMenu"  >
                    <button style="width: 180px;" (click)="generatePDF(element,'C')" mat-menu-item><mat-icon>download</mat-icon>Current</button>
                    <button style="width: 180px;" (click)="generatePDF(element,'O')" mat-menu-item><mat-icon>download</mat-icon>Original</button>
  
                    </mat-menu>
                </span>
               
                </div>
                </div>
              </div>
            </div>
            </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand" ></tr>
            <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"ß
            class="example-element-row" sticky >
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"  class="example-detail-row"></tr>
            <tr class="mat-row" *matNoDataRow>
            <td  class="mat-cell" colspan="4">There is no data in this table</td>
            </tr>
            </table>


       </mat-tab>
       <mat-tab   label="Hotel"> 
        <div *ngIf="moreFilters" class="col-md-12 mt-2 mb-2 shadow">
          <div  class="col-md-12 row">
            
            <div class="col-md-3">
              <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
              <mat-label >Hotel Name</mat-label>
              <input  matInput type="text"    name="ticketNumber"  autocomplete="off" [(ngModel)]="peraHotel.hotelName"  >
              </mat-form-field>
            </div>
      <div class="col-md-3">
              <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
                <mat-label >Corporate/Agent</mat-label>
                <!-- <input  matInput type="text"     name="corporatea&agent"  autocomplete="off" [(ngModel)]="pera.corporate"  (input)="searchByOrderId()"> -->
             
                  
               
                  <input matInput
                  [matAutocomplete]="autoHotelTo"
                  [formControl]="ToHotelCtrl" >
                <mat-autocomplete #autoHotelTo="matAutocomplete">
                  <mat-option   value="ALL"  (click)="selectedHotelTo('')" class="mat-primary" >
                    <small>{{'ALL'}}</small>
                  </mat-option>
                  <mat-option  *ngFor="let user of filteredHotelTo | async" [value]="user.name"  (click)="selectedHotelTo(user)" class="mat-primary" >
                    <small>{{user?.name}}, {{user?.userType}}</small>
                  </mat-option>
                   
                </mat-autocomplete>
          
                
              </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
          <mat-label >Passenger <small>(FirstName<mat-icon class="pt-1"> space_bar</mat-icon>LastName)</small></mat-label>
        <input  matInput type="text"     name="passenger"  autocomplete="off" [(ngModel)]="peraHotel.passenger"  (input)="searchByOrderId()">
       
    
          
        </mat-form-field>
      </div>
    <div class="col-md-3">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
        <mat-label >Booking Status</mat-label>
        <mat-select matNativeControl multiple [(ngModel)]="peraHotel.status" >
          <mat-option class="mat-primary" value="OK">Confirmed</mat-option>
          <mat-option class="mat-primary" value="HP">Pending Hotel Confirmation</mat-option>
          <mat-option class="mat-primary" value="CN">Cancelled</mat-option>
          <mat-option class="mat-primary" value="CO">Completed</mat-option>
          <mat-option class="mat-primary" value="PG">Pending</mat-option>
          <mat-option class="mat-primary" value="FD">Failed</mat-option>
          <mat-option class="mat-primary" value="PB">Partially Booked</mat-option>
          <mat-option class="mat-primary" value="CR">Cancellation Requested</mat-option>
          <mat-option class="mat-primary" value="PC">Partially Cancelled</mat-option>

          <mat-option class="mat-primary" value="N">NEW</mat-option>

          
        </mat-select>
       
        <!-- <input  matInput type="text"     name="bookedBy" placeholder="Search By PNR" autocomplete="off"   (input)="searchByOrderId()"> -->
      </mat-form-field>
    </div>
    
      <div class="col-md-3">
       
      <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
        <mat-label>From</mat-label>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <input matInput [ngxMatDatetimePicker]="pickeHotel" readonly [max]="maxDate" placeholder="Choose a date" [(ngModel)]="peraHotel.fromDate"
           [disabled]="disabled">
        <button mat-icon-button matSuffix (click)="pickeHotel.open()">
          <mat-icon>calendar_today</mat-icon>
        </button> 
        <ngx-mat-datetime-picker #pickeHotel [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
          [disableMinute]="disableMinute" [hideTime]="hideTime">
        </ngx-mat-datetime-picker> 
      </mat-form-field>
      </div>
      <div class="col-md-3">
       
      <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
        <mat-label>To</mat-label>
          <mat-hint>MM/DD/YYYY</mat-hint>
        <input matInput [ngxMatDatetimePicker]="pickerHotel" readonly [max]="maxDate" placeholder="Choose a date" [(ngModel)]="peraHotel.toDate"  
           [disabled]="disabled">
        <button mat-icon-button matSuffix (click)="pickerHotel.open()">
          <mat-icon>calendar_today</mat-icon>
        </button> 
        <ngx-mat-datetime-picker #pickerHotel [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
          [disableMinute]="disableMinute" [hideTime]="hideTime">
        </ngx-mat-datetime-picker> 
      </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1  " appearance="outline">
          <mat-label>Branch Id</mat-label>
          <!-- <input matInput type="text" name="name" autocomplete="off"> -->
          <mat-select matNativeControl   name="branchid" [(ngModel)]="peraHotel.branchId">
            <mat-option  value="">-</mat-option>
  
            <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
        </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
          <mat-label >HCN Status</mat-label>
          <mat-select matNativeControl multiple [(ngModel)]="peraHotel.hcnStatus" >
            <mat-option class="mat-primary" value="">Any</mat-option>
            <mat-option class="mat-primary" value="C">Complete</mat-option>
            <mat-option class="mat-primary" value="P">Pending </mat-option>

          
          </mat-select>
         
          <!-- <input  matInput type="text"     name="bookedBy" placeholder="Search By PNR" autocomplete="off"   (input)="searchByOrderId()"> -->
        </mat-form-field>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-3"></div>
      <div class="col-md-3"></div>

      <div class="col-md-3">
        <button    style="background-color:#4986E8;color:white;width: 100%;height: 60px;" (click)="searchByHOTELOrderId()" mat-flat-button>Search</button>

      </div>
      
          </div>
        </div>
    <div class="row col-md-12">
      <div class="col-md-4 row" >
<div class="col-md-6">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
      
      <input  matInput type="text"    name="cartHId" placeholder="Search By CartId" autocomplete="off" [(ngModel)]="peraHotel.orderId"  (input)="searchByHOTELOrderId()">
      </mat-form-field>
    </div>
<div class="col-md-6">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
      
        <input  matInput type="text"     name="pnr" placeholder="Search By Booking Id" autocomplete="off" [(ngModel)]="peraHotel.bookingId"  (input)="searchByHOTELOrderId()">
      </mat-form-field>
</div>

      
      <!-- <mat-menu #OpenDialog="matMenu" >
        <button mat-menu-item (click)="searchBy('CARTID')">Search by CartId</button>
        <button mat-menu-item (click)="searchBy('PNR')">Search by PNR</button>
      
      </mat-menu> -->
    </div>
     
      <div class="col-md-1 "><button mat-flat-button   style="color: #4986E8; cursor: pointer;font-weight: 700;margin-top: 8px;height: 50px;" (click)="hotelRefresh()"><mat-icon   >refresh</mat-icon><small style="white-space: nowrap;"><strong>Last Updated :</strong><br>{{formatDate(hotelRefDate)}}</small></button>
      </div>
      

      <mat-paginator  class="col-md-7 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100,200,300,400]"
      [length]="totalHotelElements"
      (page)="nextHotelPage($event)"
      aria-label="Select page">
      </mat-paginator>
      
      </div>
      <div class="d-flex justify-content-start" style="font-size: 12px;">
        <strong class="pt-2">Invoice Status :</strong>
       <button mat-flat-button style="background-color:orange ;color: white;margin-left: 8px;" (click)="onHotleClick('N')">NEW</button>  
       <button mat-flat-button style="background-color:rgb(231, 75, 75) ;color: white;margin-left: 8px;" (click)="onHotleClick('P')">PENDING</button>  
       <button mat-flat-button style="background-color:rgb(25, 143, 25) ;color: white;margin-left: 8px;" (click)="onHotleClick('S')">SUCCESS</button>  
       <button mat-flat-button style="background-color:rgba(6, 204, 243, 0.941) ;color: white;margin-left: 8px;" (click)="onHotleClick('')">ALL</button>  
      <!-- <mat-form-field style="margin-left: 8px;" appearance="outline">
        <mat-label>Ticket Issuance Status</mat-label>
       <mat-select matNativeControl  [(ngModel)]="pera.ticketIssuance" (selectionChange)="searchByOrderId()">
        <mat-option class="mat-primary" value="">All</mat-option>
        <mat-option class="mat-primary" value="C">Complete</mat-option>
        <mat-option class="mat-primary" value="F">Failed</mat-option>

      </mat-select>
    </mat-form-field> -->
    <div style="margin-left: 8px;">

      <button  mat-raised-button color="primary" (click)="exportHotelData()">Export Data</button>

    </div>
      </div>
      <mat-progress-bar *ngIf="showHotelTableData" mode="indeterminate"></mat-progress-bar>

            <table *ngIf="!showHotelTableData" mat-table style="font-size: 18px; "
            [dataSource]="hotelList" multiTemplateDataRows style="background-color: transparent;">
            <ng-container matColumnDef="expand">
            <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element" [style]="element.cartType==='M'?('background-color:#4986E8;'):''">
            <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
              <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
              <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
            </button>
            </td>
            </ng-container>
            <ng-container matColumnDef="generationTime">
             <th mat-header-cell *matHeaderCellDef> Generation Time </th>
             <td mat-cell *matCellDef="let element;"> {{formatDate(element?.creationTs)}} </td>
            </ng-container>
            <!-- Emp Id -->
             <ng-container matColumnDef="firstDeparture">
               <th mat-header-cell *matHeaderCellDef>Check-In</th>
               <td mat-cell *matCellDef="let element"> {{element?.hotelBooking?.hotelRequest?.checkInDate}} </td>
             </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="cartId">
              <th mat-header-cell *matHeaderCellDef> CartId </th>
              <td mat-cell *matCellDef="let element"> {{element?.uuid}} </td>
             </ng-container>
            <ng-container matColumnDef="bookedBy">
             <th mat-header-cell *matHeaderCellDef> Booked By </th>
             <td mat-cell *matCellDef="let element"> {{element?.createdBy?.split('-')[1]}} </td>
            </ng-container>
            
            <!-- email Column -->
            <ng-container matColumnDef="corporate_Agent">
             <th mat-header-cell *matHeaderCellDef>Corporate/Agent  </th>
             <td mat-cell *matCellDef="let element"> {{element?.corporate?.split('-')[1]||'-'}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Invoice Status </th>
              <td mat-cell *matCellDef="let element" [style]="element?.invoiceStatus==='S'?('background-color:rgb(25, 143, 25);color:white'):element?.invoiceStatus==='P'?('background-color:rgb(231, 75, 75);color:white'):element?.invoiceStatus==='N'?('background-color:orange;color:white'):''">
                 <!-- {{element?.invoiceStatus}}  -->
                 {{element?.invoiceStatus==='N'?('NEW'):''}}
                  {{element?.invoiceStatus==='P'?('PENDING'):''}}
                  {{element?.invoiceStatus==='S'?('SUCCESS'):''}}
                
                </td>
             </ng-container>
             <ng-container matColumnDef="summary">
              <th mat-header-cell *matHeaderCellDef>Summary </th>
              <td mat-cell *matCellDef="let element" style="padding: 4px;"><pre>Booking Id - {{element.bookingId}}{{element?.hotelItineraries[0]?.orderPassengerDetails?.length?(' _X_'+element?.hotelItineraries[0]?.orderPassengerDetails?.length):''}}</pre>

                <!-- <span *ngFor="let Itineraries of element.hotelItineraries" ><pre>{{Itineraries?.hotel}}|{{Itineraries?.city}}{{Itineraries?.orderPassengerDetails?.length?('_X_'+Itineraries?.orderPassengerDetails?.length):''}}</pre></span> -->
              </td>
             </ng-container>
             
             <ng-container matColumnDef="approvalStatus">
              <th mat-header-cell *matHeaderCellDef>Service Time </th>
              <td mat-cell *matCellDef="let element"> 
                {{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}
                </td>
             </ng-container>
             
             <ng-container matColumnDef="bookingStatus">
              <th mat-header-cell *matHeaderCellDef>Booking Status</th>
              <td mat-cell *matCellDef="let element" class="d-flex justify-content-center pt-1">
                <button *ngIf="element.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
                <button *ngIf="element.status==='PG'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>Pending</button>
                <button *ngIf="element.status==='HP'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>Pending Hotel Confirmation</button>
                <button *ngIf="element.status==='OK'"  disabled style="background-color:#44D43B;color:white;min-width: 130px;" mat-flat-button>Confirmed</button>
                <button *ngIf="element.status==='CO'"  disabled style="background-color:#1ba511;;color:white;min-width: 130px;" mat-flat-button>Completed</button>
                <button *ngIf="element.status==='PB'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                <button  *ngIf="element.status==='FD'" disabled style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                <button  *ngIf="element.status==='CN'" disabled style="background-color:#ff6f00;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
                <button  *ngIf="element.status==='CR'" disabled style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>Cancellation Requested</button>
                <button  *ngIf="element.status==='PC'" disabled style="background-color:#e69807;color:white;min-width: 140px;" mat-flat-button>Partially Cancelled</button>

               

              </td>
             </ng-container>
             <ng-container matColumnDef="paymentStatus">
              <th mat-header-cell *matHeaderCellDef>Payment Status</th>
              <td mat-cell *matCellDef="let element">
                {{element?.paymentStatus==='P'?('PAID'):''}}
                {{element?.paymentStatus==='F'?('FAILED'):''}}
                {{element?.paymentStatus==='I'?('INITIATED'):''}}
                {{element?.paymentStatus==='A'?('ABORTED'):''}}
                {{element?.paymentStatus==='U'?('UNPAID'):''}}

              </td>
             </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
            <div class="example-element-detail row"
             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
             <div class=" col-md-12  mt-2 mb-2 card shadow pb-3">
             <div class="col-md-12 d-flex justify-content-start mt-2">
            <div class="col-md-6 row">
            <span class="col-md-5 bold">Payment Status</span>
            <span class="col-md-7"> 
              {{element?.paymentStatus==='P'?('PAID'):''}}
              {{element?.paymentStatus==='F'?('FAILED'):''}}
              {{element?.paymentStatus==='I'?('INITIATED'):''}}
              {{element?.paymentStatus==='A'?('ABORTED'):''}}
            </span>
            </div>
            <div class="col-md-6 row">
              <span class="col-md-5 bold">Supplier Service Time</span>
              <span class="col-md-7"> {{element?.bookingTs?(element?.bookingRequestTs?(supplierService(element?.bookingTs,element?.bookingRequestTs)):'-'):'-'}}</span>
              </div>

            </div>
            <div class="col-md-12 d-flex justify-content-start mt-2">
              <div class="col-md-6 row">
              <span class="col-md-5 bold">Locked By/ Assigned To</span>
              <span class="col-md-7">{{"-"}}</span>
              </div>
              <div class="col-md-6 row">
                <span class="col-md-5 bold">User/Agent Service Time</span>
                <span class="col-md-7"> {{element?.bookingRequestTs?(ServiceUser(element?.bookingRequestTs,element?.creationTs)):'-'}}</span>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-start mt-2">
                <div class="col-md-6 row">
                <span class="col-md-5 bold">Request Id</span>
                <span class="col-md-7">{{element?.requestUuid||'-'}}</span>
                </div>
                <div class="col-md-6 row">
                  <span class="col-md-5 bold">Total Service Time</span>
                  <span class="col-md-7">{{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}</span>
                  </div>
                </div>
                <div class="col-md-12 d-flex justify-content-start mt-2">
                  <div class="col-md-6 row">
                  <span class="col-md-5 bold">Booking Platform</span>
                  <span class="col-md-7">{{element?.channel||'-'}}</span>
                  </div>
                  <div class="col-md-6 row">
                    <span class="col-md-5 bold">Cart Type</span>
                    <span class="col-md-7" >{{element.cartType==='A'?('Auto'):element.cartType==='M'?('Manual'):''}}</span>
                    </div>
                  </div>
                  
                  <div class="col-md-12 d-flex justify-content-start mt-2">
                    <div class="col-md-6 row">
                    <span class="col-md-5 bold">Approval Status</span>
                    <span class="col-md-7"> {{element?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                      {{element?.approvalStatus==='P'?('PENDING'):''}}
                      {{element?.approvalStatus==='D'?('DECLINED'):''}}
                      {{element?.approvalStatus==='A'?('APPROVED'):''}}
      
                      {{element?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                      {{element?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}</span>
                    </div>
                    
                    </div>
                   

                     
              <div class="col-md-12 d-flex justify-content-start mt-2">
                <div class="col-md-6  row">
                <span class="col-md-12 "> 
                  <button  (click)="onViewHClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>View Cart</button>
                  <button (click)="onModifyHClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>Modify Cart </button>
                  <button *ngIf="element.status==='OK'||element.status==='HP'||element.status==='CO'||element.status==='PB'||element.status==='PC'||element.status==='CN'" mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" [matMenuTriggerFor]="Dialog"  ><mat-icon>keyboard_arrow_down</mat-icon>Download Voucher</button>
                  <mat-menu #Dialog="matMenu"  >
                    <button style="width: 180px;" (click)="generateHotelPDF(element,'C')" mat-menu-item><mat-icon>download</mat-icon>Current</button>
                    <button style="width: 180px;" (click)="generateHotelPDF(element,'O')" mat-menu-item><mat-icon>download</mat-icon>Original</button>
  
                    </mat-menu>
                </span>
               
                </div>
                </div>
              </div>
            </div>
            </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand" ></tr>
            <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"ß
            class="example-element-row" sticky >
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"  class="example-detail-row"></tr>
            <tr class="mat-row" *matNoDataRow>
            <td  class="mat-cell" colspan="4">There is no data in this table</td>
            </tr>
            </table>


       </mat-tab>
       <mat-tab   label="Insurance"> 
        <div *ngIf="moreFilters" class="col-md-12 mt-2 mb-2 shadow">
          <div  class="col-md-12 row">
            
            <!-- <div class="col-md-3">
              <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
              <mat-label >Hotel Name</mat-label>
              <input  matInput type="text"    name="ticketNumber"  autocomplete="off" [(ngModel)]="peraInsurance.hotelName"  >
              </mat-form-field>
            </div> -->
      <!-- <div class="col-md-3">
              <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
                <mat-label >Corporate/Agent</mat-label>
             
                  
               
                  <input matInput
                  [matAutocomplete]="autoHotelTo"
                  [formControl]="ToHotelCtrl" >
                <mat-autocomplete #autoHotelTo="matAutocomplete">
                  <mat-option   value="ALL"  (click)="selectedHotelTo('')" class="mat-primary" >
                    <small>{{'ALL'}}</small>
                  </mat-option>
                  <mat-option  *ngFor="let user of filteredHotelTo | async" [value]="user.name"  (click)="selectedHotelTo(user)" class="mat-primary" >
                    <small>{{user?.name}}, {{user?.userType}}</small>
                  </mat-option>
                   
                </mat-autocomplete>
          
                
              </mat-form-field>
      </div> -->
      <!-- <div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
          <mat-label >Passenger <small>(FirstName<mat-icon class="pt-1"> space_bar</mat-icon>LastName)</small></mat-label>
        <input  matInput type="text"     name="passenger"  autocomplete="off" [(ngModel)]="peraInsurance.passenger"  (input)="searchByOrderId()">
       
    
          
        </mat-form-field>
      </div> -->
    <div class="col-md-3">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
        <mat-label >Booking Status</mat-label>
        <mat-select matNativeControl multiple [(ngModel)]="peraInsurance.status" >
          <mat-option class="mat-primary" value="BR">Request</mat-option>
          <mat-option class="mat-primary" value="B">BOOKED</mat-option>
          <mat-option class="mat-primary" value="BF">FAILED</mat-option>
          <mat-option class="mat-primary" value="PB">PARTIALLY BOOKED</mat-option>
          <mat-option class="mat-primary" value="CR">Cancellation Requested</mat-option>
          <mat-option class="mat-primary" value="C">CANCELLED</mat-option>
          <mat-option class="mat-primary" value="CF">Cancellation Failed</mat-option>
          <mat-option class="mat-primary" value="PF">Partially Cancelled</mat-option>
          <mat-option class="mat-primary" value="N">NEW</mat-option>

          
        </mat-select>
       
        <!-- <input  matInput type="text"     name="bookedBy" placeholder="Search By PNR" autocomplete="off"   (input)="searchByOrderId()"> -->
      </mat-form-field>
    </div>
    
      <!-- <div class="col-md-3">
       
      <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
        <mat-label>From</mat-label>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <input matInput [ngxMatDatetimePicker]="pickeHotel" readonly [max]="maxDate" placeholder="Choose a date" [(ngModel)]="peraInsurance.fromDate"
           [disabled]="disabled">
        <button mat-icon-button matSuffix (click)="pickeHotel.open()">
          <mat-icon>calendar_today</mat-icon>
        </button> 
        <ngx-mat-datetime-picker #pickeHotel [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
          [disableMinute]="disableMinute" [hideTime]="hideTime">
        </ngx-mat-datetime-picker> 
      </mat-form-field>
      </div> -->
      <!-- <div class="col-md-3">
       
      <mat-form-field class="col-md-12 mt-1 form-group " appearance="outline">
        <mat-label>To</mat-label>
          <mat-hint>MM/DD/YYYY</mat-hint>
        <input matInput [ngxMatDatetimePicker]="pickerHotel" readonly [max]="maxDate" placeholder="Choose a date" [(ngModel)]="peraInsurance.toDate"  
           [disabled]="disabled">
        <button mat-icon-button matSuffix (click)="pickerHotel.open()">
          <mat-icon>calendar_today</mat-icon>
        </button> 
        <ngx-mat-datetime-picker #pickerHotel [showSpinners]="showSpinners" [showSeconds]="showSeconds"
          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
          [disableMinute]="disableMinute" [hideTime]="hideTime">
        </ngx-mat-datetime-picker> 
      </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="col-md-12 mt-1  " appearance="outline">
          <mat-label>Branch Id</mat-label>
          <mat-select matNativeControl   name="branchid" [(ngModel)]="peraHotel.branchId">
            <mat-option  value="">-</mat-option>
  
            <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
        </mat-select>
        </mat-form-field>
      </div> -->
      <div class="col-md-3">
        <button    style="background-color:#4986E8;color:white;width: 100%;height: 60px;" (click)="InsuranceList()" mat-flat-button>Search</button>

      </div>
      <div class="col-md-3"></div>
      <div class="col-md-3"></div>
      <div class="col-md-3"></div>

     
      
          </div>
        </div>
    <div class="row col-md-12">
      <div class="col-md-4 row" >
<div class="col-md-6">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
      
      <input  matInput type="text"    name="cartHId" placeholder="Search By CartId" autocomplete="off" [(ngModel)]="peraHotel.orderId"  (input)="searchByHOTELOrderId()">
      </mat-form-field>
    </div>
<div class="col-md-6">
      <mat-form-field class="col-md-12 mt-1 form-group "   appearance="outline">
      
        <input  matInput type="text"     name="pnr" placeholder="Search By Booking Id" autocomplete="off" [(ngModel)]="peraHotel.bookingId"  (input)="searchByHOTELOrderId()">
      </mat-form-field>
</div>

      
      <!-- <mat-menu #OpenDialog="matMenu" >
        <button mat-menu-item (click)="searchBy('CARTID')">Search by CartId</button>
        <button mat-menu-item (click)="searchBy('PNR')">Search by PNR</button>
      
      </mat-menu> -->
    </div>
     
      <div class="col-md-1 "><button mat-flat-button   style="color: #4986E8; cursor: pointer;font-weight: 700;margin-top: 8px;height: 50px;" (click)="insuranceRefresh()"><mat-icon   >refresh</mat-icon><small style="white-space: nowrap;"><strong>Last Updated :</strong><br>{{formatDate(insuranceRefDate)}}</small></button>
      </div>
      

      <mat-paginator  class="col-md-7 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100,200,300,400]"
      [length]="totalInsurancelElements"
      (page)="nextInsurancePage($event)"
      aria-label="Select page">
      </mat-paginator>
      
      </div>
      <div class="d-flex justify-content-start" style="font-size: 12px;">
        <strong class="pt-2">Invoice Status :</strong>
       <button mat-flat-button style="background-color:orange ;color: white;margin-left: 8px;" (click)="onInsuranceClick('N')">NEW</button>  
       <button mat-flat-button style="background-color:rgb(231, 75, 75) ;color: white;margin-left: 8px;" (click)="onInsuranceClick('P')">PENDING</button>  
       <button mat-flat-button style="background-color:rgb(25, 143, 25) ;color: white;margin-left: 8px;" (click)="onInsuranceClick('S')">SUCCESS</button>  
       <button mat-flat-button style="background-color:rgba(6, 204, 243, 0.941) ;color: white;margin-left: 8px;" (click)="onInsuranceClick('')">ALL</button>  
      <!-- <mat-form-field style="margin-left: 8px;" appearance="outline">
        <mat-label>Ticket Issuance Status</mat-label>
       <mat-select matNativeControl  [(ngModel)]="pera.ticketIssuance" (selectionChange)="searchByOrderId()">
        <mat-option class="mat-primary" value="">All</mat-option>
        <mat-option class="mat-primary" value="C">Complete</mat-option>
        <mat-option class="mat-primary" value="F">Failed</mat-option>

      </mat-select>
    </mat-form-field> -->
    <div style="margin-left: 8px;">

      <button  mat-raised-button color="primary" (click)="exportHotelData()">Export Data</button>

    </div>
      </div>
      <mat-progress-bar *ngIf="showInsuranceTableData" mode="indeterminate"></mat-progress-bar>

            <table *ngIf="!showInsuranceTableData" mat-table style="font-size: 18px; "
            [dataSource]="insuranceList" multiTemplateDataRows style="background-color: transparent;">
            <ng-container matColumnDef="expand">
            <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element" [style]="element.cartType==='M'?('background-color:#4986E8;'):''">
            <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
              <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
              <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
            </button>
            </td>
            </ng-container>
            <ng-container matColumnDef="generationTime">
             <th mat-header-cell *matHeaderCellDef> Generation Time </th>
             <td mat-cell *matCellDef="let element;"> {{formatDate(element?.creationTs)}} </td>
            </ng-container>
            <!-- Emp Id -->
             <ng-container matColumnDef="firstDeparture">
               <th mat-header-cell *matHeaderCellDef>Channel</th>
               <td mat-cell *matCellDef="let element"> {{element?.channel}} </td>
             </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="cartId">
              <th mat-header-cell *matHeaderCellDef> CartId </th>
              <td mat-cell *matCellDef="let element"> {{element?.uuid}} </td>
             </ng-container>
            <ng-container matColumnDef="bookedBy">
             <th mat-header-cell *matHeaderCellDef> Booked By </th>
             <td mat-cell *matCellDef="let element"> {{element?.createdBy?.split('-')[1]}} </td>
            </ng-container>
            
            <!-- email Column -->
            <ng-container matColumnDef="corporate_Agent">
             <th mat-header-cell *matHeaderCellDef>Corporate/Agent  </th>
             <td mat-cell *matCellDef="let element"> {{element?.corporate?.split('-')[1]||'-'}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Invoice Status </th>
              <td mat-cell *matCellDef="let element" [style]="element?.invoiceStatus==='S'?('background-color:rgb(25, 143, 25);color:white'):element?.invoiceStatus==='P'?('background-color:rgb(231, 75, 75);color:white'):element?.invoiceStatus==='N'?('background-color:orange;color:white'):''">
                 <!-- {{element?.invoiceStatus}}  -->
                 {{element?.invoiceStatus==='N'?('NEW'):''}}
                  {{element?.invoiceStatus==='P'?('PENDING'):''}}
                  {{element?.invoiceStatus==='S'?('SUCCESS'):''}}
                
                </td>
             </ng-container>
             <ng-container matColumnDef="summary">
              <th mat-header-cell *matHeaderCellDef>Summary </th>
              <td mat-cell *matCellDef="let element" style="padding: 4px;">

                <span *ngFor="let Itineraries of element.insuranceItineraries" ><pre>{{Itineraries?.insuranceItineraries?('Policy Number - '+Itineraries?.insuranceItineraries+' |'):''}}{{Itineraries?.persons?.name||''}}</pre></span>
              </td>
             </ng-container>
             
             <ng-container matColumnDef="approvalStatus">
              <th mat-header-cell *matHeaderCellDef>Service Time </th>
              <td mat-cell *matCellDef="let element"> 
                {{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}
                </td>
             </ng-container>
             
             <ng-container matColumnDef="bookingStatus">
              <th mat-header-cell *matHeaderCellDef>Booking Status</th>
              <td mat-cell *matCellDef="let element" class="d-flex justify-content-center pt-1">
                <!-- <button *ngIf="element.status==='PG'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>Pending</button>
                <button *ngIf="element.status==='HP'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>Pending Hotel Confirmation</button>
                <button *ngIf="element.status==='CO'"  disabled style="background-color:#1ba511;;color:white;min-width: 130px;" mat-flat-button>Completed</button>
                 -->
                <button *ngIf="element.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
                <button *ngIf="element.status==='BR'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>Request</button>
                <button *ngIf="element.status==='B'"  disabled style="background-color:#44D43B;color:white;min-width: 130px;" mat-flat-button>BOOKED</button>
                <button  *ngIf="element.status==='BF'" disabled style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                <button *ngIf="element.status==='PB'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                <button  *ngIf="element.status==='CR'" disabled style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>Cancellation Requested</button>
                <button  *ngIf="element.status==='C'" disabled style="background-color:#ff6f00;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>
                <button  *ngIf="element.status==='CF'" disabled style="background-color:#ff6f00;color:white;min-width: 140px;" mat-flat-button>Cancellation Failed</button>
                <button  *ngIf="element.status==='PF'" disabled style="background-color:#e69807;color:white;min-width: 140px;" mat-flat-button>Partially Cancelled</button>

               

              </td>
             </ng-container>
             <ng-container matColumnDef="paymentStatus">
              <th mat-header-cell *matHeaderCellDef>Payment Status</th>
              <td mat-cell *matCellDef="let element">
                {{element?.paymentStatus==='P'?('PAID'):''}}
                {{element?.paymentStatus==='F'?('FAILED'):''}}
                {{element?.paymentStatus==='I'?('INITIATED'):''}}
                {{element?.paymentStatus==='A'?('ABORTED'):''}}
                {{element?.paymentStatus==='U'?('UNPAID'):''}}

              </td>
             </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
            <div class="example-element-detail row"
             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
             <div class=" col-md-12  mt-2 mb-2 card shadow pb-3">
             <div class="col-md-12 d-flex justify-content-start mt-2">
            <div class="col-md-6 row">
            <span class="col-md-5 bold">Payment Status</span>
            <span class="col-md-7"> 
              {{element?.paymentStatus==='P'?('PAID'):''}}
              {{element?.paymentStatus==='F'?('FAILED'):''}}
              {{element?.paymentStatus==='I'?('INITIATED'):''}}
              {{element?.paymentStatus==='A'?('ABORTED'):''}}
            </span>
            </div>
            <div class="col-md-6 row">
              <span class="col-md-5 bold">Supplier Service Time</span>
              <span class="col-md-7"> {{element?.bookingTs?(element?.bookingRequestTs?(supplierService(element?.bookingTs,element?.bookingRequestTs)):'-'):'-'}}</span>
              </div>

            </div>
            <div class="col-md-12 d-flex justify-content-start mt-2">
              <div class="col-md-6 row">
              <span class="col-md-5 bold">Locked By/ Assigned To</span>
              <span class="col-md-7">{{"-"}}</span>
              </div>
              <div class="col-md-6 row">
                <span class="col-md-5 bold">User/Agent Service Time</span>
                <span class="col-md-7"> {{element?.bookingRequestTs?(ServiceUser(element?.bookingRequestTs,element?.creationTs)):'-'}}</span>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-start mt-2">
                <div class="col-md-6 row">
                <span class="col-md-5 bold">Request Id</span>
                <span class="col-md-7">{{element?.requestUuid||'-'}}</span>
                </div>
                <div class="col-md-6 row">
                  <span class="col-md-5 bold">Total Service Time</span>
                  <span class="col-md-7">{{element?.bookingTs?(totalService(element?.bookingTs,element?.creationTs)):'-'}}</span>
                  </div>
                </div>
                <div class="col-md-12 d-flex justify-content-start mt-2">
                  <div class="col-md-6 row">
                  <span class="col-md-5 bold">Booking Platform</span>
                  <span class="col-md-7">{{element?.channel||'-'}}</span>
                  </div>
                  <div class="col-md-6 row">
                    <span class="col-md-5 bold">Cart Type</span>
                    <span class="col-md-7" >{{element.cartType==='A'?('Auto'):element.cartType==='M'?('Manual'):''}}</span>
                    </div>
                  </div>
                  
                  <div class="col-md-12 d-flex justify-content-start mt-2">
                    <div class="col-md-6 row">
                    <span class="col-md-5 bold">Approval Status</span>
                    <span class="col-md-7"> {{element?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                      {{element?.approvalStatus==='P'?('PENDING'):''}}
                      {{element?.approvalStatus==='D'?('DECLINED'):''}}
                      {{element?.approvalStatus==='A'?('APPROVED'):''}}
      
                      {{element?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                      {{element?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}</span>
                    </div>
                    
                    </div>
                   

                     
              <div class="col-md-12 d-flex justify-content-start mt-2">
                <div class="col-md-6  row">
                <span class="col-md-12 "> 
                  <button  (click)="onViewIClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>View Cart</button>
                  <button (click)="onModifyIClick(element)" style="background-color:#4986E8;color:white;margin-right: 8px;min-width: 130px;" mat-flat-button>Modify Cart </button>
                  <button *ngIf="element.status==='OK'||element.status==='HP'||element.status==='CO'||element.status==='PB'||element.status==='PC'||element.status==='CN'" mat-flat-button  style="background-color:#4986E8;color:white; font-size: 17px;" [matMenuTriggerFor]="Dialog"  ><mat-icon>keyboard_arrow_down</mat-icon>Download Voucher</button>
                  <mat-menu #Dialog="matMenu"  >
                    <button style="width: 180px;" (click)="generateHotelPDF(element,'C')" mat-menu-item><mat-icon>download</mat-icon>Current</button>
                    <button style="width: 180px;" (click)="generateHotelPDF(element,'O')" mat-menu-item><mat-icon>download</mat-icon>Original</button>
  
                    </mat-menu>
                </span>
               
                </div>
                </div>
              </div>
            </div>
            </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand" ></tr>
            <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"ß
            class="example-element-row" sticky >
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"  class="example-detail-row"></tr>
            <tr class="mat-row" *matNoDataRow>
            <td  class="mat-cell" colspan="4">There is no data in this table</td>
            </tr>
            </table>


       </mat-tab>


      </mat-tab-group>
</div>

      </div>
  </div>
 </div>
 <div *ngIf="showStatus && screenChange">
<app-cart-status></app-cart-status>
 </div>
 <div *ngIf="modifyCart && screenChange">
  <app-modify-cart></app-modify-cart>
     </div>
